import React from 'react';
import { Modal } from '@mantine/core';
import { takeAwayChannelLabel, type OrderView } from 'shared-models/browser';
import { CibusOrderPanel } from './CibusOrderPanel';

type CibusOrderModalProps = {
  order: OrderView | null;
  tenantId: string;
  employeeSession: string | null;
  onClose: () => void;
  onAccepted?: (order: OrderView) => void;
};

// List-row entry point (incl. the paid list, where accepted packages await יצא למשלוח).
export const CibusOrderModal: React.FC<CibusOrderModalProps> = ({ order, tenantId, employeeSession, onClose, onAccepted }) => (
  <Modal
    opened={order !== null}
    onClose={onClose}
    title={order ? `הזמנת ${takeAwayChannelLabel(order.orderCode)} ${order.orderCode}` : ''}
    centered
    radius="md"
    size="md"
    zIndex={301}
    closeButtonProps={{ 'data-testid': 'cibus-order-modal-close' } as Record<string, string>}
  >
    {order && (
      <CibusOrderPanel tenantId={tenantId} employeeSession={employeeSession} order={order} onAccepted={onAccepted} onDone={onClose} />
    )}
  </Modal>
);
